import axios from "axios";
import { showToast } from "../mixins/Common";
import { store } from "../store/store";
import AdminService from "@/services/AdminService";

export default () => {
  let apiHeaders = {
    "Content-Type": "application/json"
  };

  let token = localStorage.getItem("token");

  if (token !== null) apiHeaders["MY_TOKEN"] = token;

  let apiRequest = axios.create({
    headers: apiHeaders
  });

  apiRequest.interceptors.request.use(function (config) {
    if (config.data !== undefined) {
      let body = config.data;
      let str = JSON.stringify(body);
      str = str.replace(/=/g, "★~eq~★");
      str = str.replace(/&/g, "★~and~★");
      config.data = JSON.parse(str);
    }
    return config;
  });

  apiRequest.interceptors.response.use(
    response => {
      return response;
    },
    function (error) {
      store.dispatch("setLoading", false);
      if (typeof error.response === "undefined") {
        return Promise.reject(error);
      } else {
        //check unauthorized
        if (error.response.status === 401) {
          store.dispatch("setLoading", true);
          AdminService.logout().then(response => {
            if (response.status == 200) {
              localStorage.removeItem("token");
              store.dispatch("setAdmin", null);
              location.reload();
            }
          });
        }

        // check error toast
        else if (error.response.data.payload.toast != null)
          showToast(error.response.data.payload.toast);
        // check server validation errors
        else if (error.response.data.payload.errors != null) {
          return Promise.reject(error);
        }
      }
    }
  );

  return apiRequest;
};
